$(function () {
  const target = $(".grade-search-list > li");
  target.on("click", function () {
    if ($(this).children("a").attr("href").indexOf("void") > -1) {
      target.removeClass("-cr");
      $(this).addClass("-cr");
    }
  });
});

//グレード一覧
$(function () {
  const showmoreList = $(".productsDetail-grade__hideCon");
  const showmoreListOpen = parseInt(showmoreList.outerHeight(true));
  const showmoreListClose = 400;
  showmoreList.css("height", showmoreListClose + "px");
  $(".productsDetail-grade__toggle a").click(function () {
    const thisBtn = $(this);
    if ($(this).hasClass("openLink")) {
      thisBtn.removeClass("openLink").addClass("closeLink").parent().addClass("close_area");
      showmoreList.css("height", showmoreListOpen + "px");
    } else if ($(this).hasClass("closeLink")) {
      thisBtn.removeClass("closeLink").addClass("openLink").parent().removeClass("close_area");
      showmoreList.css("height", showmoreListClose + "px");
    }
  });
});

$(function () {
  $(".productsDetail-qa__hideConBtn a, .productsDetail-qa__hideConClose").on("click", function () {
    $(".qa__body").slideToggle(500, "swing");
    if ($(".productsDetail-qa__hideConBtn a").hasClass("openLink")) {
      $(".productsDetail-qa__hideConBtn a").removeClass("openLink").addClass("closeLink");
    } else if ($(".productsDetail-qa__hideConBtn a").hasClass("closeLink")) {
      $(".productsDetail-qa__hideConBtn a").removeClass("closeLink").addClass("openLink");
    }
  });
});

$(function ($) {
  if (window.matchMedia && window.matchMedia("(max-device-width: 767px)").matches) {
    $(".table-grade").each(function (index, element) {
      //pc版テーブル退避
      $(this).children("tbody").children("tr").css("display", "none");
      var td_block = "";
      var i = 0;
      //データ名取得
      $(this)
        .children("tbody")
        .children("tr")
        .each(function (index, element) {
          var cnt_tr = $(this).length;
          td_block += $(this)
            .children("th")
            .replaceWith('<th colspan="3">' + $(this).children("th").eq(0).text() + "</th>");
          for (let f = 0; f < cnt_tr; f++) {
            for (let i = 0; i < 7; i = i + 3) {
              if (i == 0) {
                td_block += '<tr><th colspan="3">' + $(this).children("th").eq(f).text() + "</th></tr>";
              }
              td_block +=
                '<tr><td><a href="' +
                $(this)
                  .children("td")
                  .eq(0 + i)
                  .children("a")
                  .attr("href") +
                '">' +
                $(this)
                  .children("td")
                  .eq(0 + i)
                  .text() +
                '</a></td><td><a href="' +
                $(this)
                  .children("td")
                  .eq(1 + i)
                  .children("a")
                  .attr("href") +
                '">' +
                $(this)
                  .children("td")
                  .eq(1 + i)
                  .text() +
                '</a></td><td><a href="' +
                $(this)
                  .children("td")
                  .eq(2 + i)
                  .children("a")
                  .attr("href") +
                '">' +
                $(this)
                  .children("td")
                  .eq(2 + i)
                  .text() +
                "</a></td></tr>";
            }
          }
        });
      //sp版テーブル追加
      $(this).children("tbody").append(td_block);
      //td 一列目が空なら行ごと削除
      $(this)
        .children("tbody")
        .children("tr")
        .each(function (index, element) {
          var th_text = $(this).children("th").eq(0).text();
          var td_text = $(this).children("td").eq(0).text();
          if (th_text == "" && td_text == "") {
            $(this).remove();
          }
        });
    });
    return true;
  } else {
    return false;
  }
});

$(function ($) {
  var grade_title = $(".products-characteristic__list h2").text();
  if (grade_title.match(/レオナ/)) {
  } else {
    grade_title = grade_title.replace(/[テナック,レオナ,ザイロン]+™/g, "");
    $(".table-grade tbody tr").each(function (index, element) {
      $(this)
        .children("td")
        .each(function (index, element) {
          if ($(this).text() === grade_title) {
            $(".products-gradeClass li:last-child").text($(this).parent("tr").children("th").text());
            return false;
          }
        });
    });
  }
});

// 高機能グレードページ
const current_href = $('select[name="highGradeSelect"] option:selected').val();
$('select[name="highGradeSelect"]').on("change", function () {
  const href = $(this).val();
  if (href !== current_href) {
    location.href = href;
  }
});

if (location.hash == "#highGradeNav") {
  const mvBottomPos = $(".products-v2__mv").offset().top + $(".products-outline__mv").height();
  $(function ($) {
    $("html, body").scrollTop(mvBottomPos - $(".l-header").height());
  });
}

// 高機能グレードのナビの開閉
const highGradeTarget = $(".productsHighgrade__nav:not('.always-open')");
if (highGradeTarget.length > 0) {
  $(".js-highGradeOpen, .productsHighgrade__nav").on({
    mouseover: function () {
      if (!highGradeTarget.hasClass("is-open")) {
        highGradeTarget.addClass("is-open");
      }
    },
    mouseout: function () {
      highGradeTarget.removeClass("is-open");
    },
  });
}
